export const getCombinationKey = (payload) => {
  const { area, room, roof, materials, house_look } = payload;

  return `${house_look}${area}${room}${roof}${[...(materials || [])]
    .sort()
    .join("")}`;
};
